module.exports = __webpack_public_path__ + "img/white-list-icon.cf346171.svg";